import { axios } from '@/services/axios';

const deleteUserProfile = async ({
    numberID,
    platformId,
    platformUserId,
    scope,
    token,
}) => {
    const res = await axios.delete(
        `/UserProfile?NumberID=${numberID}&PlatformID=${platformId}&PlatformUserID=${platformUserId}`,
        {
            headers: {
                authorization: `Bearer ${token}`,
                'X-RequestScope': scope,
            },
        },
    );
    return res.data;
};

export default deleteUserProfile;
